import React, { useState, useEffect } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
// @ts-ignore
import { Modal, Tooltip, OverlayTrigger, Button, Form } from "react-bootstrap";
import { customName, getColorFromId } from "../../helpers/commonHelpers";
import constatntMessages from "../../constants/constatntMessages";
import axios from "../../../node_modules/axios/index";
import { fetchIpAddress } from "../../helpers/commonHelpers";
import { useSelector, useDispatch } from "react-redux";
import { setInValidUser } from "../../redux/actions/authActions/authAction";
import { handleApiError } from "../../helpers/errorResponseHelper";
import SmallLoaderButton from "../Common/SmallLoaderButton";
import { fetchExistingGuest } from "../../redux/actions/meetingActions/MeetingAction";
import { getSingleMeetingDetails } from "../../redux/actions/meetingActions/MeetingAction";

const GuestAttendeesModal = React.memo((props) => {
  const { attendees, IsGuestModalOpen, setIsGuestModalOpen } = props;
  const [errors, setErrors] = useState({});
  const [editGuestId, setEditGuestId] = useState(null);
  const [editGuestData, setEditGuestData] = useState({});
  const [isGuestOption, setIsGuestOption] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [localAttendees, setLocalAttendees] = useState(attendees);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const organizationId = userData?.organizationId;
  const dispatch = useDispatch();
  const location = useLocation();
  const stateData = location.state;

  useEffect(() => {
    if (IsGuestModalOpen) {
      setLocalAttendees(attendees);
    }
  }, [attendees, IsGuestModalOpen]);

  const tooltip = (attendee) => (
    <Tooltip id="tooltip">
      {attendee.name} / {attendee?.email}
    </Tooltip>
  );

  const handleEditClick = (guest) => {
    setEditGuestId(guest._id);
    // @ts-ignore
    setIsGuestOption(true);
    setEditGuestData({ ...guest });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditGuestData((prev) => ({ ...prev, [name]: value }));
  };

  const isValidString = (value) =>
    typeof value === "string" &&
    value.trim().length >= 2 &&
    value.trim().length <= 100;

  const guestEditIsValidate = () => {
    const errors = {};
    const excludeHtml = /^[0-9a-zA-Z .(),\-_/]+$/;

    if (!editGuestData.name || !editGuestData.name.trim()) {
      errors.editName = "Guest Name is required";
    } else if (!excludeHtml.test(editGuestData.name)) {
      errors.editName = constatntMessages.invalidInput;
    } else if (!isValidString(editGuestData.name)) {
      errors.editName = "Name must be 2 - 100 characters";
    }

    if (editGuestData.department) {
      if (!excludeHtml.test(editGuestData.department)) {
        errors.editDepartment = constatntMessages.invalidInput;
      } else if (!isValidString(editGuestData.department)) {
        errors.editDepartment = "Department Name must be 2 - 100 characters";
      }
    }

    if (editGuestData.designation) {
      if (!excludeHtml.test(editGuestData.designation)) {
        errors.editDesignation = constatntMessages.invalidInput;
      } else if (!isValidString(editGuestData.designation)) {
        errors.editDesignation = "Designation Name must be 2 - 100 characters";
      }
    }

    if (editGuestData.companyName) {
      if (!excludeHtml.test(editGuestData.companyName)) {
        errors.editCompanyName = constatntMessages.invalidInput;
      } else if (!isValidString(editGuestData.companyName)) {
        errors.editCompanyName = "Company Name must be 2 - 100 characters";
      }
    }

    if (editGuestData.role) {
      if (!excludeHtml.test(editGuestData.role)) {
        errors.editRole = constatntMessages.invalidInput;
      } else if (!isValidString(editGuestData.role)) {
        errors.editRole = "Role must be 2 - 100 characters";
      }
    }

    const whatsAppTrimmed = (editGuestData.whatsAppNo || "").toString().trim();
    if (whatsAppTrimmed) {
      const whatsappRegex = /^\d{10}$/;
      if (!whatsappRegex.test(whatsAppTrimmed)) {
        errors.editWhatsAppNo = constatntMessages.whatsAppNo;
      }
    }

    setErrors(errors);
    return errors;
  };

  const updateErrors = (field, message) => {
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (message) {
        newErrors[field] = message;
      } else {
        delete newErrors[field];
      }
      return newErrors;
    });
  };

  const updateCompanyNameValidationCheck = () => {
    const excludeHtmlForName = /^[0-9a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!excludeHtmlForName.test(editGuestData.companyName)) {
      updateErrors("editCompanyName", constatntMessages.invalidInput);
    }
  };

  const updateRoleValidationCheck = () => {
    const excludeHtmlForName = /^[0-9a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!excludeHtmlForName.test(editGuestData.role)) {
      updateErrors("editRole", constatntMessages.invalidInput);
    } else {
      updateErrors("editRole", null);
    }
  };

  const updateDesignationValidationCheck = () => {
    const excludeHtmlForName = /^[0-9a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!excludeHtmlForName.test(editGuestData.designation)) {
      updateErrors("editDesignation", constatntMessages.invalidInput);
    } else {
      updateErrors("editDesignation", null);
    }
  };
  const updateDepartmentValidationCheck = () => {
    const excludeHtmlForName = /^[0-9a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!excludeHtmlForName.test(editGuestData.department)) {
      updateErrors("editDepartment", constatntMessages.invalidInput);
    } else {
      updateErrors("editDepartment", null);
    }
  };

  const updateGuestNameValidationCheck = () => {
    const excludeHtml = /^[0-9a-zA-Z ,&,/-]+$/;
    const excludeHtmlForName = /^[a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!editGuestData.name.trim()) {
      updateErrors("editName", "Guest Name is required");
    } else if (!excludeHtmlForName.test(editGuestData.name)) {
      updateErrors("editName", constatntMessages.invalidInputContactPersonName);
    } else {
      updateErrors("editName", null);
    }
  };

  const handleSave = async () => {

    const originalGuest = attendees.find((item) => item._id === editGuestId);
    const isUnchanged =
      originalGuest?.name === editGuestData.name &&
      originalGuest?.designation === editGuestData.designation &&
      originalGuest?.department === editGuestData.department &&
      originalGuest?.companyName === editGuestData.companyName &&
      originalGuest?.whatsAppNo === editGuestData.whatsAppNo &&
      originalGuest?.role === editGuestData.role;
    if (isUnchanged) {
      toast.error("No changes", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    const name = editGuestData?.name;
    const email = editGuestData?.email;
    const department = editGuestData?.department;
    const whatsAppNo = editGuestData?.whatsAppNo;
    const designation = editGuestData?.designation;
    const companyName = editGuestData?.companyName;
    const role = editGuestData?.role;

    const newErrors = guestEditIsValidate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const updateGuest = {
      name,
      email,
      department,
      whatsAppNo,
      designation,
      organizationId,
      companyName,
      role,
    };
    setIsEditLoading(true);
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/V1/employee/editGuest/${editGuestId}`,
        updateGuest,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
            ip: await fetchIpAddress(),
          },
        }
      );

      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
        // toast.error(response.data.message);
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        dispatch(setInValidUser(false));
      }

      if (response.data.success) {
        // toast.success(response.data.message);
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        if (props?.meetingId) {
          dispatch(getSingleMeetingDetails(props.meetingId, accessToken));
        }
        setEditGuestId(null); // Exit edit mode
        // dispatch(
        //   fetchExistingGuest(userData.organizationId, accessToken)
        // );
        // setErrors({ ...errors, editEmployeeData: "" });
        setLocalAttendees((prev) =>
          prev.map((guest) =>
            guest._id === editGuestId ? { ...guest, ...updateGuest } : guest
          )
        );
        setErrors("");
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      if (handleApiError(error)) return;
      console.log("Error while updating guest:", error);
    } finally {
      setIsEditLoading(false);
      setIsGuestOption(false);
    }
  };

  const handleCancel = () => {
    setEditGuestId(null);
    setIsGuestOption(false);
    setEditGuestData({});
  };

  const closeButton = () => {
    setEditGuestId(null);
    setIsGuestOption(false);
    setIsGuestModalOpen(false);
  };

  const handleKeyDown = (e) => {
    const { name, value } = e.target;
    const invalidKeys = ["e", "E", "+", "-", ".", ","];
    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }
    if (name === "whatsAppNo") {
      if (value.length >= 10 && ![8, 37, 39, 46].includes(e.keyCode)) {
        e.preventDefault();
      }
    }
  };

  return (
    <Modal
      show={IsGuestModalOpen}
      onHide={() => setIsGuestModalOpen(false)}
      backdrop="static"
    >
      <Modal.Header>
        {isGuestOption ? (
          <Modal.Title>Edit Guest</Modal.Title>
        ) : (
          <Modal.Title>Guest(s)</Modal.Title>
        )}
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={closeButton}
        ></button>
      </Modal.Header>

      <Modal.Body>
        <div className="attendees-popup">
          {localAttendees &&
            localAttendees
              .filter((item) => !item.empId)
              .filter(
                (attendee) => !editGuestId || attendee._id === editGuestId
              )
              .map((attendee, index) => {
                const isEditing = attendee._id === editGuestId;
                return (
                  <div
                    className="attendee-content align-items-start"
                    key={index}
                  >
                    <div>
                      {!isEditing && (
                        <div
                          className="attendee1 attendee-list sl"
                          style={{
                            backgroundColor: attendee?.profilePicture
                              ? undefined
                              : getColorFromId(attendee._id),
                            borderRadius: "50px",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "32px",
                            height: "32px",
                          }}
                        >
                          <OverlayTrigger
                            placement="top"
                            overlay={tooltip(attendee)}
                            trigger={["hover", "focus"]}
                          >
                            {attendee?.profilePicture ? (
                              <img
                                src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                                alt=""
                                className="attendee-profile-picture icon-image"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = "none";
                                  e.target.parentElement.style.backgroundColor =
                                    getColorFromId(attendee._id);
                                  e.target.parentElement.innerText = customName(
                                    attendee.name
                                  );
                                }}
                              />
                            ) : (
                              <span>{customName(attendee.name)}</span>
                            )}
                          </OverlayTrigger>
                        </div>
                      )}
                    </div>

                    <div className="action-cmnt-text w-100">
                      {isEditing ? (
                        <Form>
                          <Form.Group className="mb-3">
                            <Form.Label className="mb-1">Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="name"
                              value={editGuestData.name}
                              onChange={handleInputChange}
                              onBlur={updateGuestNameValidationCheck}
                            />
                            {errors.editName && (
                              <span className="error-message">
                                {errors.editName}
                              </span>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="mb-1">Email</Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              value={editGuestData.email}
                              onChange={handleInputChange}
                              readOnly
                            />
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="mb-1">
                              Designation
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="designation"
                              value={editGuestData.designation || ""}
                              onChange={handleInputChange}
                              onBlur={updateDesignationValidationCheck}
                            />
                            {errors.editDesignation && (
                              <span className="error-message">
                                {errors.editDesignation}
                              </span>
                            )}
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label className="mb-1">Role</Form.Label>
                            <Form.Control
                              type="text"
                              name="role"
                              value={editGuestData.role || ""}
                              onChange={handleInputChange}
                              onBlur={updateRoleValidationCheck}
                            />
                            {errors.editRole && (
                              <span className="error-message">
                                {errors.editRole}
                              </span>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="mb-1">Department</Form.Label>
                            <Form.Control
                              type="text"
                              name="department"
                              value={editGuestData.department || ""}
                              onChange={handleInputChange}
                              onBlur={updateDepartmentValidationCheck}
                            />
                            {errors.editDepartment && (
                              <span className="error-message">
                                {errors.editDepartment}
                              </span>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="mb-1">
                              Company Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="companyName"
                              value={editGuestData.companyName || ""}
                              onChange={handleInputChange}
                              onBlur={updateCompanyNameValidationCheck}
                            />
                            {errors.editCompanyName && (
                              <span className="error-message">
                                {errors.editCompanyName}
                              </span>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="mb-1">
                              WhatsApp Number
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="whatsAppNo"
                              value={editGuestData.whatsAppNo || ""}
                              onChange={handleInputChange}
                              onKeyDown={handleKeyDown}
                            />
                            {errors.editWhatsAppNo && (
                              <span className="error-message">
                                {errors.editWhatsAppNo}
                              </span>
                            )}
                          </Form.Group>
                        </Form>
                      ) : (
                        <>
                          <div className="d-flex justify-content-between edit-guest-details">
                            <div className="w-100 pr-15px">
                              <p className="font-bold-500">{attendee.name}</p>
                              <p className="">{attendee.email}</p>
                              {attendee?.designation && (
                                <div className="detail-date-time mt-1 des-comp">
                                  <span>Designation - </span>
                                  {attendee.designation}
                                </div>
                              )}
                              {attendee?.role && (
                                <div className="detail-date-time mt-1 des-comp">
                                  <span>Role - </span>
                                  {attendee.role}
                                </div>
                              )}
                              {attendee?.department && (
                                <div className="detail-date-time mt-1 des-comp">
                                  <span>Department - </span>
                                  {attendee.department}
                                </div>
                              )}
                              {attendee?.companyName && (
                                <div className="detail-date-time des-comp">
                                  <span>Company Name - </span>
                                  {attendee.companyName}
                                </div>
                              )}
                            </div>
                            <div>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleEditClick(attendee)}
                              >
                                <div className="d-flex align-items-center lineheight-14">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15"
                                    height="15"
                                    fill="currentColor"
                                    className="me-2 bi bi-pencil-square"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path
                                      fillRule="evenodd"
                                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                    />
                                  </svg>
                                  Edit
                                </div>
                              </Button>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
        </div>
      </Modal.Body>
      {isGuestOption && (
        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2">
            <Button
              className="add-minutes Mom-btn btn"
              size="sm"
              onClick={handleCancel}
            >
              <p className="mb-0">Cancel</p>
            </Button>
            {isEditLoading ? (
              <SmallLoaderButton />
            ) : (
              <Button
                className="Mom-btn btn btn-secondary edit-guest-save-btn"
                size="sm"
                onClick={handleSave}
              >
                <p className="mb-0">Save</p>
              </Button>
            )}
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
});

export default GuestAttendeesModal;
